module.exports = __webpack_public_path__ + "img/Flag_of_Greece.b41b5f52.svg";